import { render, staticRenderFns } from "./CustomFilter.vue?vue&type=template&id=1dda3ff3&scoped=true&"
import script from "./CustomFilter.vue?vue&type=script&lang=js&"
export * from "./CustomFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomFilter.vue?vue&type=style&index=0&id=1dda3ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda3ff3",
  null
  
)

export default component.exports